exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".touching-edges[data-v-0a99fc08]{margin-left:-1px}", ""]);

// exports
